export default "__VITE_ASSET__nPaopy9l__"